module.exports = __webpack_public_path__ + "static/media/oiui400_imgstamp.007d3dbb.ico";